import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './Navbar.module.scss';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUsers, faEnvelope, faUserShield, faMap, faPlusCircle } from '@fortawesome/free-solid-svg-icons';

const Navbar = () => {
  const { isAuthenticated } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);


 

  useEffect(() => {
    const fetchUnreadCount = async () => {
      const token = localStorage.getItem('token');
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/messages/unread/count`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUnreadCount(res.data.count);
      } catch (err) {
        console.error('Failed to fetch unread message count', err);
      }
    };

    if (isAuthenticated) {
      fetchUnreadCount();
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) return null;

  return (
    <nav className={styles.navbar}>
      <ul>
        <li>
          <Link to="/home">
            <FontAwesomeIcon icon={faHome} className={styles.icon} />
            <span className={styles.linkText}>Home</span>
          </Link>
        </li>
        <li>
          <Link to="/dashboard">
            <FontAwesomeIcon icon={faUsers} className={styles.icon} />
            <span className={styles.linkText}>User Management</span>
          </Link>
        </li>
        <li>
          <Link to="/messages">
            <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
            <span className={styles.linkText}>Messages</span>
            {/*  {unreadCount > 0 && <span className={styles.unreadCount}>{unreadCount}</span>} */}
          </Link>
        </li>
        <li>
          <Link to="/add-role">
            <FontAwesomeIcon icon={faUserShield} className={styles.icon} />
            <span className={styles.linkText}>Role Management</span>
          </Link>
        </li>
        <li>
          <Link to="/plots">
            <FontAwesomeIcon icon={faMap} className={styles.icon} />
            <span className={styles.linkText}>Plot Management</span>
          </Link>
        </li>
        <li>
          <Link to="/add-plot">
            <FontAwesomeIcon icon={faPlusCircle} className={styles.icon} />
            <span className={styles.linkText}>Upload Plot</span>
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
